import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { switchAndCreateBrowserWallet } from "../usecases/repositories/common";

import { configJsonState } from "../states/configJsonState";
import { useRecoilState, useRecoilValue } from 'recoil';//取得のみ


type Props = {
    buttonText: string,
}


//GetNFTButton コンポーネントの定義
export const NoWalletButton: React.FC<Props> = (props) => {
  const configStatus = useRecoilValue(configJsonState);
  const [walletTypeArrayStatus , setWalletTypeArrayStatus] = React.useState([]);


  const nav = useNavigate();
  const noWalletButtonStyle: React.CSSProperties = {
    boxSizing: 'border-box',
    width: '314px',
    height: '60px',
    background: 'linear-gradient(92.35deg, #FFB16A -17.7%, #FAEBB8 45.92%, #FFB16A 119.55%)',
    border: '0.5px solid rgba(239, 239, 239, 0.2)',
    boxShadow: 'inset 0px 1px 0px rgba(255, 255, 255, 0.6)',
    borderRadius: '80px',
    transition: 'all 0.5s',
    backgroundImage: `url('https://nfttopshot-template.onrender.com/template-images/btn-orange-bg.png')`,
    color: 'rgba(255, 177, 106, 1)',
    fontWeight: 500,
  };

  React.useEffect(()=>{
    (async() => {

    })();
  },[]);
  return (
    <div>
        <button 
          className='btn btn-primary btn-neumo' 
          style={noWalletButtonStyle} 
          id="btn-default-getnft-nowallet" 
          type="button"
          onClick={()=>{
                switchAndCreateBrowserWallet(nav('/3'));
            }
          }
        >
          <img className="navbar-toggler-icon" src='https://nfttopshot-template.onrender.com/template-images/icon-nft.png' />&nbsp;{props.buttonText}
         </button>
    </div>
  );
};